export const isCompanyFeatureEnabled = (features, feature) =>
  !feature || features?.[feature] !== false;
